import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export enum StatusColor {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  INFO = 'info',
  PRIMARY = 'primary',
}

@Component({
  selector: 'app-status-indicator',
  templateUrl: './status-indicator.component.html',
  styleUrls: ['./status-indicator.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class StatusIndicatorComponent {
  @Input() text!: string;
  @Input() color!: StatusColor | string;
}
